import React from 'react';
import { motion } from 'framer-motion';

const Marquee = () => {
  const industries = [
    'Healthcare',
    'Finance',
    'Technology',
    'Retail',
    'Manufacturing',
    'Education',
    'Legal',
    'Real Estate',
    'Hospitality',
    'Construction'
  ];

  // Duplicate for seamless loop
  const duplicatedIndustries = [...industries, ...industries];

  return (
    <section className="relative py-20 bg-slate-900 overflow-hidden">
      <div className="mb-8 text-center">
        <h3 className="text-sm text-slate-400 uppercase tracking-widest font-semibold">
          Serving All Industries
        </h3>
      </div>
      
      <div className="relative">
        <motion.div
          className="flex gap-12 whitespace-nowrap"
          animate={{
            x: [0, -1920]
          }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: 30,
              ease: "linear"
            }
          }}
        >
          {duplicatedIndustries.map((industry, index) => (
            <div
              key={index}
              className="text-4xl lg:text-5xl font-bold text-slate-700 hover:text-blue-400 transition-colors duration-300 cursor-default"
            >
              {industry}
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Marquee;
